import {combineReducers} from 'redux';
import enrollments from './enrollments-reducer';
import admin from './admin-reducer';

const rootReducer = combineReducers({
    enrollments,
    admin
});

export default rootReducer;